<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        VR+船舶消防”使演练更贴近真实
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-05-18</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
      <p class="indentation">
        船舶消防具有特殊性，其规律和特点一直是航海与消防领域关注的热点。船舶火灾具有严重危险性，易导致重大人身伤亡事故和巨大财产损失。目前，船舶消防训练大都在真实环境中进行，成本高、危险性大，且污染环境。近年来，虚拟现实技术不断发展和成熟，为船舶消防训练提供了新的思路。
      </p>
      <p class="indentation">
        大连海大智龙科技有限公司创新推出船舶消防VR演练系统，以“VR+船舶消防”的形式，打破对船员培训的传统“说教”形式，以低成本、高效率、常态化的虚拟培训模式，为船舶消防培训领域提供全新的解决方案。用户佩戴VR头显，通过视觉、听觉等感知虚拟的船舶三维环境和逼真的火灾场景，从而产生一种身临其境的感觉。以“实际参与”的形式深入到灭火的整个过程，使用户熟悉船舶火灾的各种紧急情况并采取正确的救火措施，有利于提高船员的业务技能，提高船员对船舶消防事故的应变能力，保障人船安全。
      </p>
      <p class="indentation">
        船舶消防VR演练系统中，不仅有针对不同舱室、场景的体验内容，且可根据客户的不同需求定制开发，目前已完成《基于固定式二氧化碳系统的船舶消防VR演练》、《基于固定水灭火系统的船舶消防VR演练》、《船舶固定式二氧化碳灭火系统使用与维护保养VR系统》等多余款VR培训软件。
      </p>
    </div>
    <div class="div-row div-bottom10">
      <div class="  div-top box2">
        <div class="div-margin ">
          <img src="../../../assets/images/news17/1.png" />
        </div>
      </div>
    </div>

    <div class="div-row div-bottom10  ">
      <div class="  div-top box2">
        <div class="div-margin news-Medium-18">
          <B> 整船的模拟</B>
        </div>
        <p class=" indentation-22">基于固定式二氧化碳系统的船舶消防VR演练</p>

        <p class="indentation">
          培训人员佩戴VR头显设备，通过模拟货舱失火场景，对船员报警、二氧化碳释放等操作过程进行训练，实现在虚拟环境中的“实战演练”，提高船舶突发火灾时的应对能力。
        </p>

      </div>
    </div>



    <div class="div-row div-bottom10  ">
      <div class=" div-margin">
        <div class="div-margin ">
          <img src="../../../assets/images/news17/3.png" />
          <img src="../../../assets/images/news17/2.png" />
        </div>
        <div class="row ">
          <div class="col-lg-6 news-Medium-18">
            <B> 货舱失火场景VR体验 </B>
          </div>
          <div class=" col-lg-6 news-Medium-18">
            <B> 货舱二氧化碳的释放</B>
          </div>
        </div>
      </div>
    </div>
    <div class="div-row div-bottom10  ">
      <div class="  div-top box2">
              <p class=" indentation-22">船舶固定式二氧化碳灭火系统使用与维护保养VR系统</p>

        <p class="indentation">
         培训人员佩戴VR头显设备，通过模拟的船舱内厨房失火情形，对船员报警、集合、扑救等过程进行演练，重点对船舶固定水灭火系统操作流程进行演练，提高船舶突发火灾时的应对能力。
        </p>
      </div>
    </div>

    <div class="div-row div-bottom10">
      <div class="  div-top box2">
        <div class="div-margin ">
          <img src="../../../assets/images/news17/4.png" />
        </div>
      </div>
    </div>



    <div class="div-row div-bottom10  ">
      <div class="  div-top box2">
   <div class="div-margin news-Medium-18">
          <B> 使用水枪进行厨房灭火</B>
        </div>
        <p class=" indentation-22">船舶固定式二氧化碳灭火系统使用与维护保养VR系统</p>

        <p class="indentation">
          培训人员佩戴VR头显设备，沉浸在模拟的火灾场景中。根据船舱不同的故障类型，采取对应的二氧化碳释放方式，进行灭火体验。同时根据实际教学和应用需求，增加对二氧化碳间的维护保养操作。使培训人员更充分地了解和学习船舶二氧化碳间消防设备的使用及完整的二氧化碳间维护保养流程。
        </p>

      </div>
    </div>




    <div class="div-row div-bottom10">
      <div class=" div-top box2">
        <div class="row ">
          <div class="col-lg-8 news-Medium-18">
            <div class="div-margin ">
              <img src="../../../assets/images/news17/5.png" />
            </div>
            <B> 船舶固定式二氧化碳灭火系统使用与维护保养VR系统主界面 </B>
          </div>
          <div class=" col-lg-4 news-Medium-18">
            <div class="div-margin ">

              <img src="../../../assets/images/news17/6.png" />

              <B> 手操气动释放二氧化碳</B>
            </div>
            <div class="div-margin ">

              <img src="../../../assets/images/news17/7.png" />

              <B> 二氧化碳间的维护保养</B>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div class="div-row div-bottom10  ">
        <p class="indentation">
         船舶消防VR演练系统，通过体验式教学，确保了消防人员的安全，并可通过反复演练，达到训练目的，提高培训效率，同时减少培训成本。
        </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 95%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news17.vue